import {
  ADD_FAVORITE,
  SET_FAVORITE_LOADING,
  SET_FAVORITE_ERROR
} from '../actionTypes'

const initialState = {
  favorites: [],
  loading: false,
  error: false
}

function favoriteReducer(state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case ADD_FAVORITE:
      return { ...state, favorites: [...state.favorites, payload] }
    case SET_FAVORITE_LOADING:
      return { ...state, loading: payload }
    case SET_FAVORITE_ERROR:
      return { ...state, error: payload }
    default:
      return state
  }
}

export default favoriteReducer